<script setup lang="ts">

import { RouterView, useRouter } from 'vue-router';
import { onMounted } from 'vue';

const router = useRouter();

onMounted(() => {
	const mainLoader = document.getElementById('main-loader');
	if (!mainLoader) return;

	// Nascondi il loader solo quando la prima navigazione è completata
	// (incluso il download del chunk lazy della route)
	router.isReady().then(() => {
		mainLoader.style.display = 'none';
	});
});

</script>

<template>
	<RouterView />
</template>